import { Component } from '@angular/core';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  cookies: Object;
  sessionId: string;
  constructor() {
          this.cookies = Cookie.getAll();
         // console.log(this.cookies);
       }

       	ngOnInit() {
	}


  title = 'app';
}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/app.component.ts